import { MatDialogRef } from "@angular/material/dialog";
import { LevelInfoService } from "./../../../../services/http/business/levelInfo/level-info.service";
import { FormGroup, FormBuilder } from "@angular/forms";
import { Component, OnInit, Inject } from "@angular/core";
import { TranslateService } from "@ngstack/translate";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { MAT_DIALOG_DATA } from "@angular/material";
import { ITeacher } from "src/app/interfaces/teacher";
import { SoundEnum } from "src/app/enums/sound.enum";

@Component({
  selector: "app-teacher-to-lvl-entry",
  templateUrl: "./teacher-to-lvl-entry.component.html",
  styleUrls: ["./teacher-to-lvl-entry.component.css"]
})
export class TeacherToLvlEntryComponent implements OnInit {
  form: FormGroup;
  list: any[];
  actionsId: number[] = [];
  LevelList = [];
  teacherLevels: any;
  // packageList
  constructor(
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    private translate: TranslateService,
    private levelInfoService: LevelInfoService,
    @Inject(MAT_DIALOG_DATA) public data: ITeacher,
    private dialogref: MatDialogRef<TeacherToLvlEntryComponent>
  ) { }

  ngOnInit() {
    this.createForm();
    this.loadLevelsThatAssignedToTeacher();
    this.loadLevels();
  }

  createForm() {
    this.form = this.fb.group([
      {
        levels: [null]
      }
    ]);
  }

  loadLevels() {
    this.levelInfoService.getAllLevelForTeacher().subscribe(res => {
      var result = [];

      res.DataList.forEach(
        (function (hash) {
          return function (a) {
            if (!hash[a.PackageName]) {
              hash[a.PackageName] = {
                PackageName: a.PackageName,
                activities: []
              };
              result.push(hash[a.PackageName]);
            }
            hash[a.PackageName].activities.push({
              Code: a.Code,
              ExpireDay: a.ExpireDay,
              Id: a.Id,
              IsActive: a.IsActive,
              IsGraduatedLevel: a.IsGraduatedLevel,
              Name: a.Name,
              PackageId: a.PackageId,
              PackageName: a.PackageName
            });
          };
        })(Object.create(null))
      );

      this.list = result;
      this.levelInfoService
      .ListLevelPerson(this.data.NationalCode)
      .subscribe(res => {
        // this.teacherLevels = res;
        // this.LevelList = res.LevelList;

        result.forEach(ac => {
          ac.activities.forEach(element => {
            //  var a = this.LevelList.indexOf(element.Id);
            if (res.LevelList.indexOf(element.Id) > -1) {
              element.selected = true;
            }
            // if (element.selected)
            //   xList.push(element.Id);
          });
        });

      });

    });
  }

  loadLevelsThatAssignedToTeacher() {
    this.levelInfoService
      .ListLevelPerson(this.data.NationalCode)
      .subscribe(res => {
        this.teacherLevels = res;
        this.LevelList = res.LevelList;
      });
  }

  check(aId: number) {
    if (this.teacherLevels) {
      for (let id of this.teacherLevels.LevelList) {
        if (id == aId) {
          return true;
        }
      }
    }
  }

  selectAll(event, packageItem: any) {
    if (event.checked) {
      packageItem.activities.forEach(element => {
        element.selected = true;
      });
    }
    else {
      packageItem.activities.forEach(element => {
        element.selected = false;
      });
    }

  }
  checkList(event, level) {
    // if (this.LevelList == null) {
    //   this.LevelList = new Array();
    // }
    // if (event.checked) {
    //   this.LevelList.push(id);
    // }
    // if (!event.checked) {
    //   let index = this.LevelList.indexOf(id);
    //   if (index > -1) {
    //     this.LevelList.splice(index, 1);
    //   }
    // }
    level.selected = event.checked
  }

  submit() {
    var xList = [];
    this.list.forEach(ac => {
      ac.activities.forEach(element => {
        if (element.selected) {
          xList.push(element.Id);
        }
      });
    });
    var xData = {
      NationalCode: this.data.NationalCode,
      LevelList: xList
    };
    this.levelInfoService.SaveLevelToPerson(xData).subscribe(() => {
      this.dialogref.close();
      this.snackBar.OpenSnackBar(
        this.translate.get("success.registration"),
        "ok",
        5000,
        SoundEnum.beep
      );
    });
  }

  onClose() {
    this.dialogref.close();
  }
}
